import Model from '@/models/Model'

export default class SlDetailSaleCreditNote extends Model {

	get wh_product_name() {
		return this.getProperty('wh_product.name', '-')
	}

  resource() {
    return 'sl_detail_sale_credit_note'
  }
}